/* eslint-disable import/no-dynamic-require */
/* eslint-disable no-shadow */

const state = {
	isSidebarOpen: false,
	isMobileView: false,
	isTabletView: false,
	isMobileMenuOpen: false,
	isMenuCollapsed: false,
	isMenuShadow: false,
	isMenuUnfixed: false,
	isChatOnline: false,
	menuLayoutType: 'left', // left, top, nomenu
	menuType: 'blue', // default, flyout, compact
	menuColor: 'dark', // dark, blue, gray, white
	flyoutMenuColor: 'dark', // dark, blue, gray, white
	systemLayoutColor: 'gray', // white, dark, blue, gray, image
	isTopbarFixed: false,
	isContentNoMaxWidth: true,
	isAppMaxWidth: false,
	isGrayBackground: true,
	isGrayTopbar: false,
	isCardShadow: false,
	isSquaredBorders: false,
	isBorderless: false,
	routerAnimation: 'zoom-fadein', // none, slide-fadein-up, slide-fadein-right, fadein, zoom-fadein
	inputSize: 'default',
	menu: [],
	custom: null,
	audio: 'popup.mp3',
	requestSilent: false,
	requestPreventDestructure: false,
	formCache: true,
	dealListTables: false,
	couponListTables: false,
};

const getters = {
	settings: state => state,
	menu: st => st.menu,
	requestSilent: st => st.requestSilent,
	requestPreventDestructure: st => st.requestPreventDestructure,
};

const mutations = {
	CHANGE_SETTING(state, payload) {
		state[payload.setting] = payload.value;
	},
	SETUP_URL_SETTINGS(state, payload) {
		let queryParams = payload;
		if (payload.redirect) {
			const str = payload.redirect;
			const qIndex = str.indexOf('?');
			if (qIndex >= 0) {
				try {
					queryParams = Object.fromEntries(new URLSearchParams(str.substring(qIndex + 1)).entries());
				} catch (e) { /* malformed redirect — keep defaults */ }
			}
		}
		delete queryParams.redirect;
		const keys = Object.keys(queryParams);
		if (keys.length) {
			keys.forEach((key) => {
				if (key in state) { state[key] = queryParams[key] === 'true'; }
			});
		}
	},
	// SET MENU
	SET_MENU(st, menu) {
		st.menu = menu;
	},
	REQUEST_SILENT(st, val) {
		st.requestSilent = val;
	},
	REQUEST_PREVENT_DESTRUCTURE(st, val) {
		st.requestPreventDestructure = val;
	},
};

const actions = {
	setMenu({ commit }) {
		const defaultMenu = require('../../config/_menu').default;

		commit('SET_MENU', defaultMenu);
	},
};

export default {
	state,
	getters,
	actions,
	mutations,
};
